module.exports = __webpack_public_path__ + "static/9-4828a95eccca3e4355d550c105f9924b.jpg";